import { createSlice } from '@reduxjs/toolkit';

export const shippingModel = createSlice({
  name: 'shippingModel',
  initialState: {
    data: '1',
  },

  reducers: {
    setShippingModel: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setShippingModel } = shippingModel.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getShippingModel = (state) => state.shippingModel.data;

export default shippingModel.reducer;
